<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ currencyLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pt-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm5>
            <v-text-field
              label="Name"
              v-model="c.name"
              @input="$v.c.name.$touch()"
              @blur="$v.c.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              label="Code"
              v-model="c.code"
              @input="$v.c.code.$touch()"
              @blur="$v.c.code.$touch()"
              :error-messages="codeErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              label="Symbol"
              v-model="c.symbol"
              @input="$v.c.symbol.$touch()"
              @blur="$v.c.symbol.$touch()"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  CURRENCY_CREATE_MUTATION,
  CURRENCY_UPDATE_MUTATION
} from "../../../../constants/graphql";
import { required } from "vuelidate/lib/validators";

export default {
  name: "CurrencyEditorDialog",

  props: {
    currency: {
      type: Object,
      default: () => ({})
    },

    doSaveCurrency: {
      type: Boolean,
      default: false
    },

    currencyEditorDialog: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      c: { ...this.currency }
    };
  },

  methods: {
    saveCurrency() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context === "edit"
            ? CURRENCY_UPDATE_MUTATION
            : CURRENCY_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.c,
              currencyId: this.currency.id
            }
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    }
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    context() {
      return this.currency.id != null ? "edit" : "create";
    },
    currencyLabel() {
      return this.currency.id != null ? this.currency.name : "New Currency";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.c.name.$dirty) {
        return errors;
      }
      if (!this.$v.c.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    codeErrors() {
      let errors = [];
      if (!this.$v.c.code.$dirty) {
        return errors;
      }
      if (!this.$v.c.code.required) {
        errors.push("Code is required.");
      }
      return errors;
    }
  },

  watch: {
    currency(data) {
      let currency = { ...data };
      delete currency.__typename;
      this.c = currency;
    },

    doSaveCurrency(value) {
      if (value) {
        this.saveCurrency();
      }
    },

    currencyEditorDialog(value) {
      if (!value) {
        this.c = {};
        this.$v.$reset();
      }
    }
  },

  validations: {
    c: {
      name: { required },
      code: { required }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/currencies/CurrencyEditor.vue